module.exports = __webpack_public_path__ + "media/images/riders/BAPTISTE_PIERRON-b9dbeb7c739d1d90a91fcb6333f3211b.png";